/* Social Proof Atlas v1 - minimal JS */
(function () {
  // Smooth scroll for in-page anchors
  document.querySelectorAll('.sp-section a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.querySelector(a.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // Carousel arrow nav (UGC + BA)
  document.querySelectorAll('.sp-carousel-nav').forEach(function (nav) {
    var track = nav.previousElementSibling;
    if (!track) return;
    nav.querySelectorAll('[data-dir]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var first = track.firstElementChild;
        var step = first ? first.offsetWidth + 14 : 300;
        track.scrollBy({ left: parseInt(btn.getAttribute('data-dir'), 10) * step, behavior: 'smooth' });
      });
    });
  });
})();
